import PlansAPIs from '@/API/subscription/plans-api'
import { PackageModel } from '@/models/subscription/PackageModel'
import { FeatureModel } from '@/models/subscription/FeatureModel'

type PricingStateType = {
  packages: { trial: Array<PackageModel>; 'non-trial': Array<PackageModel> };
  features: Array<FeatureModel>;
  fetched: boolean;
  allPackages: Array<PackageModel>;
  packageFeatures: Array<FeatureModel>;
}

const pricingState: PricingStateType = {
  packages: { trial: [], 'non-trial': [] },
  features: [],
  fetched: false,
  allPackages: [],
  packageFeatures: [],
}

export default {
  namespaced: true,
  state: pricingState,
  getters: {
    pricesFetched: (state: PricingStateType) => state.fetched,
    trialPackages: (state: PricingStateType) => state.packages.trial ?? [],
    regularPackages: (state: PricingStateType) => state.packages['non-trial'] ?? [],
    freePackage: (state: PricingStateType) => state.packages['non-trial'].find(p => p.type === 'free'),
    paidPackages: (state: PricingStateType) => state.packages['non-trial'].filter(p => p.type === 'paid'),
    addons: (state: PricingStateType) => state.features,
    allPackages: (state: PricingStateType) => state.packages['non-trial'].concat(state.packages.trial),
    packageFeatures: (state: any) => state.packageFeatures ?? [],
  },
  mutations: {
    SET_PRICING(state: any, { packages, features }: any) {
      state.features = features ?? state.features
      state.packages = packages ?? state.packages
      state.fetched = true
    },
    SET_PACKAGE_FEATURES(state: any, features: any) {
      state.packageFeatures = features
    },
  },
  actions: {
    async FETCH_PRICING({ state, commit }: any, force: any) {
      if (state.fetched && !force) return true
      const { packages, features } = await PlansAPIs.getPackagesList()
      commit('SET_PRICING', { packages, features })
      return true
    },
    async FETCH_FEATURES({ state, commit }: any, force: any) {
      if (state.packageFeatures?.length && !force) return true
      const features = await PlansAPIs.getFeatures('package')
      commit('SET_PACKAGE_FEATURES', features)
      return true
    },
  },
}
